var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Card',{attrs:{"title":"被保人信息"}},[_c('Form',{staticClass:"mt15",attrs:{"label-width":150}},[_c('Row',[_c('Col',{attrs:{"span":"12"}},[_c('FormItem',{attrs:{"label":"被保险人："}},[_vm._v("\n\t\t\t\t\t\t"+_vm._s(_vm.insuredList.subjectName)+"\n\t\t\t\t\t")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69b92b6c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/haierProduct/components/my/customizedDadi/common/InsuredPersonInfo.vue
// module id = null
// module chunks = 